import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';

const useBnplStatus = () => {
   const getBnplStatus = async () => {
      const { data } = await Axios.get('/hy-providers/v1/bnpl/check');
      return data?.data;
   };

   return useQuery(['bnpl-status'], getBnplStatus, {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 0,
      onError: (error: Error) => {
         sentryCaptureException(error, { tags: { journey: 'profile' } });
      },
   });
};

export default useBnplStatus;
